import { getTextStyles, squareBlockCSS, styledOmitCustomProps } from '@braskai/ui-kit';

import { ButtonBase, css, styled } from '@mui/material';

export const SWorkspaceButton = styled(
  ButtonBase,
  styledOmitCustomProps,
)<{ $isOpen: boolean }>(
  ({ theme, $isOpen }) => css`
    font-family: ${theme.typography.fontFamily};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    width: 100%;
    height: 56px;
    padding: 8px ${$isOpen ? 10 : 2}px;
    border-radius: 10px;
    overflow: hidden;
    text-align: left;
    transition:
      padding ${theme.transitions.duration.shorter}ms,
      background-color ${theme.transitions.duration.shortest}ms;

    &:hover,
    &[aria-expanded='true'] {
      background-color: ${theme.palette.grey[50]};
    }

    &:focus-visible {
      outline: 2px solid ${theme.palette.primary[500]};
      outline-offset: -2px;
    }
  `,
);

export const SWorkspaceAvatar = styled('span')(
  ({ theme }) => css`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    ${squareBlockCSS(40)};
    border-radius: 10px;
    background-color: ${theme.palette.primary[100]};
    font-family: ${theme.typography.fontFamily};
    font-size: 15px;
    font-weight: 600;
    line-height: 1;
    color: ${theme.palette.primary[700]};
  `,
);

export const SWorkspaceText = styled('span')(
  () => css`
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 0;
  `,
);

export const SWorkspaceName = styled('span')(
  ({ theme }) => css`
    ${getTextStyles('body-2-md')};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: ${theme.palette.grey[900]};
  `,
);

export const SWorkspacePlan = styled('span')(
  ({ theme }) => css`
    ${getTextStyles('caption-1')};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: ${theme.palette.grey[500]};
  `,
);

export const SWorkspaceChevron = styled(
  'span',
  styledOmitCustomProps,
)<{ $isMenuOpen: boolean }>(
  ({ theme, $isMenuOpen }) => css`
    display: flex;
    flex-shrink: 0;
    ${squareBlockCSS(16)};
    color: ${theme.palette.grey[400]};
    transform: rotate(${$isMenuOpen ? 180 : 0}deg);
    transition: transform 0.2s;

    svg {
      width: 100%;
      height: 100%;
    }
  `,
);
